<template>
  <div>
    <Header></Header>
    <div id="main">
      <div id="categories" v-if="store">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <a class="back-button" href="javascript:history.go(-1)"><font-awesome-icon :icon="['fas', 'arrow-left']" size="lg" /> Retornar à página principal</a>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="page-title">
                <h2>{{store.Info.name}}</h2>
                <span>Lista de todos os descontos</span>
              </div>
              <div class="no-coupons" v-if="coupons && coupons.length == 0">
                <h5>Não há ofertas disponíveis para essa loja no momento.</h5>
                <span>Deseja receber novidades desta loja? Insira seu e-mail abaixo:</span>
                <form>
                  <div class="form-group">
                    <input placeholder="Informe o seu e-mail" :readonly="readonly" type="email" class="news-coupon form-control" v-model="email"/>
                  </div>
                  <small v-if="msg">{{msg}}</small>
                  <small class="error" v-if="msgErro">{{msgErro}}</small>
                  <small class="success" v-if="msgSucesso">{{msgSucesso}}</small>
                  <button @click.stop.prevent="submitNewsletter()" class="btn btn-default btn-lg">Cadastrar</button>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="result" v-if="coupons && coupons.length > 0">
                  
                <div class="row coupon" v-for="(coupon, c) in coupons" :key="c" @click="openCouponModal(coupon)">
                  <div class="col-md-3">
                    <div class="image">
                      <img :src="store.logo"/>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <div class="categorie" v-if="coupon.category">
                      <span>{{coupon.category}}</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>{{coupon.store}}</h4>
                        <span>{{coupon.description}}</span>
                        <span v-if="coupon.value > 100" class="value">R$ {{coupon.value}}</span>
                        <span v-if="coupon.value < 100" class="value">{{coupon.value}}%</span>
                        <span v-else>&nbsp;</span>
                      </div>
                      <div class="action">
                        <button @click="openCouponModal(coupon)" class="btn">Ver Desconto</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div class="row description" v-if="store.description">
            <div class="col-md-12">
              <span v-html="store.description"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CouponModal :coupon="selectedCoupon" v-bind:store="store" ref="couponModal"></CouponModal>
    <Footer></Footer>
    <Loading v-if="loading" message="Aguarde, carregando descontos da loja..."></Loading>
    
    <b-modal ref="mustLogin" hide-footer title="Você não está logado">
      <div class="d-block text-center">
        <h3>Olá! Você precisa estar logado para visualizar o cupom.</h3>
      </div>
      <b-btn class="mt-3" variant="outline-success" block @click="goToLogin">Entrar</b-btn>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Fechar</b-btn>
    </b-modal>
  </div>
</template>

<script>
import Header from './../includes/Header';
import Footer from './../includes/Footer';
import Loading from './../includes/Loading'
import CouponModal from './CouponModal';
import CouponService from '../../services/coupon';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faArrowLeft} from '@fortawesome/fontawesome-free-solid'
import auth from '../../services/auth'
import { API } from '../../services/api'

export default {
  name: 'Store',
  components: {
    Header, Footer, CouponModal, Loading, FontAwesomeIcon
  },
  data () {
    return {
      loading: true,
      store: null,
      stores: null,
      coupons: null,
      selectedCoupon: null,
      email: null,
      msg: null,
      msgSucesso: null,
      msgErro: null,
      readonly: false,
    }
  },
  created(){
    // if(!auth.isAuth()){
    //   this.$router.push('/');
    // }
    // var $this = this;
    // var date = new Date();
    // var dateString = date.getFullYear() + date.getMonth() + date.getDate();
    // var stores = {};

    // if(localStorage.getItem('stores-' + dateString)){
    //   stores = JSON.parse(localStorage.getItem('stores-' + dateString));
    //   var storeKey = Object.keys(stores).filter((s) => {
    //       return s === $this.$route.params.slug
    //   });
    //   $this.store = stores[storeKey];
    //   if($this.store){
    //     CouponService.getStoreCoupons($this.store.idLomadee, $this.store.idAwin, $this.store.type, (coupons) => {
    //       $this.coupons = coupons;
    //       $this.loading = false;
    //     });
    //   }
    // }
  },
  mounted(){
    this.loadStore();
    // var $this = this;
    // CouponService.getStores((stores) => {
    //   var storeKey = Object.keys(stores).filter((s) => {
    //     return s === $this.$route.params.slug
    //   });
    //   $this.store = stores[storeKey];
    //   if($this.store){
    //     CouponService.getStoreCoupons($this.store.idLomadee, $this.store.idAwin, $this.store.type, (coupons) => {
    //       $this.coupons = coupons;
    //       $this.loading = false;
    //     });
    //   }
      // $this.coupons = coupons.filter((c) => {
      //   return c.slug === $this.$route.params.slug
      // });
    // })
  },
  methods: {
    loadStore(){
      this.$http.get(API.Stores.list).then((result) => {
        this.stores = result.body;
        var store = this.stores.filter((s) => {
          return s.slug == this.$route.params.storeSlug;
        });
        this.store = store[0];
        var $this = this;
        CouponService.getStoreCoupons(this.store.lomadeeId, this.store.awinId, this.store.rakutenId, this.store.type, (coupons) => {
          $this.coupons = coupons;
        });
        this.loading = false;
      }, (err) => {
        console.log(err)
        this.store = null;
        this.coupons = [];
      });
    },
    submitNewsletter(){
      this.msgSucesso = null;
      this.msgErro = null;
      this.msg = null;
      this.readonly = true;
      this.msg = 'Aguarde...';
      this.$http.post(API.Contact.newsletter, {type: 'store', store: this.$route.params.storeSlug, email: this.email}).then((res) => {
          this.msgErro = null;
          this.msg = null;
          this.msgSucesso = res.body.message;
          this.readonly = false;
          this.email = null;
        }, (err) => {
          this.msgErro = err.body.message;
          this.msgSucesso = null;
          this.msg = null;
          this.readonly = false;
        });
    },
    openCouponModal(coupon){
      // if(auth.isAuth()){
        this.selectedCoupon = coupon;
        this.$refs.couponModal.open();
      // }else{
        // this.$refs.mustLogin.show()
      // }
    },
    goToLogin(){
      this.$router.push('/login-and-redirect/' + this.project.slug);
      this.$refs.mustLogin.hide()
    },
    hideModal(){
      this.$refs.mustLogin.hide()
    },
    getStore(){

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#main{
  padding-top: 160px;
  padding-bottom: 100px;
  background-color: #f7f7f7;
}
.page-title{
  text-align: center;
}
.back-button{
  color: #00cc67;
  text-decoration: none;
  font-size: 22px;
}
#categories{
  min-height: 400px;
  
  .no-coupons{
    text-align: center;
    margin-top: 20px;

    form{
      .form-group{
        width: 50%;
        margin: 0 auto;
        margin-top: 20px;

        input{
          text-align: center;
        }
      }

      button{
        margin-top: 20px;
        color: #fff;
        background-color: #00cc67;
      }
    }
  }

  small{
    display: block;
    margin-top: 10px;
    font-size: 14px;
    color: yellow;
    text-shadow: 1px 1px 1px #000;
    &.success{
      color: #00AE39;
    }
    &.error{
      color: red;
    }
  }

  .description{
    margin-top: 40px;
  }

  .sidebar-search{
    width: 100%;
    margin-top: 20px;
    // position: fixed;

    .sidebar-header{
      background-color: #363b4d;
      color: #fff;
      padding: 10px;
      font-size: 14px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    .search-field{
      border: thin solid #eaedef;
      .header{
        width: 100%;
        background-color: #f7f7f7;
        color: #363b4d;
        padding: 10px;
        font-size: 14px;
        border-bottom: thin solid #eaedef;
      }
      .field{
        background-color: #fcfcfc;
        padding: 15px;
      }
      .btn{
        background-color: #00cc67;
        color: #fff;
        width: 100%;
        border-radius: 50px;
        font-weight: bold;
      }
    }
  }

  .result{
    width: 100%;
    display: table;

    .coupon{
      width: 100%;
      margin: 0px !important;
      margin-top: 20px !important;
      padding-top: 10px;
      padding-bottom: 10px;
      transition: box-shadow 0.3s ease-in-out;
      background-color: #fff;
      cursor: pointer;

      &:hover{
        box-shadow: 0px 2px 10px #999;

        .action{
          .btn{
            background-color: #00cc67;
            color: #fff;
            border-color: #00cc67;

            &.fav{
              background-color: red;
              border-color: red;
            }
          }
        }

        .coupon-info{
          h4{
            font-weight: bold;
          }
        }
      }
      .image{
        position: relative;

        .flag{
          position: absolute;
          font-size: 12px;
          background-color: red;
          color: #fff;
          padding: 4px;
          top: 10px;
          left: -5px;
          border-radius: 5px;
          box-shadow: 2px 2px 5px #999;
        }
        img{
          border-radius: 4px;
          width: 100%;
        }
      }

      .categorie{
        span{
          font-size: 12px;
          padding-bottom: 5px;
          border-bottom: thin solid #ccc;
          width: 100%;
          display: block;
        }
      }

      .coupon-info{
        margin-top: 10px;
        .info{
          h4{
            color: #00cc67;
            font-size: 16px;
          }
          span{
            font-size: 12px;
            display: block;
            width: 100%;
            text-align: justify;

            &.value{
              font-size: 20px;
              font-weight: bold;
              text-align: center;
              padding: 5px;
            }
          }
        }
      }
      .action{
        .btn{
          width: 100%;
          background-color: #f7f7f7;
          border-color: #f7f7f7;
          color: #4b4f5d;
          font-size: 20px;
          font-weight: bold;
          margin-top: 20px;
          &.fav{
            width: 25%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/descontosdobem/Store.vue